export default __webpack_public_path__ + "static/media/sandwich.97c0c05f.png";